<script lang="ts" setup>
import SimpleBaseDialog from '@/components/dialogs/SimpleBaseDialog.vue'

withDefaults(
  defineProps<{
    loading?: boolean
  }>(),
  { loading: false }
)

const emit = defineEmits<{
  action: []
  close: []
}>()

const { t } = useI18n()
const { defaultSender } = storeToRefs(useBusinessStore())
</script>

<template>
  <simple-base-dialog
    :title="t('business.emails.remove.title')"
    :action-text="t('business.emails.remove.confirm')"
    :cancel-text="t('global.cancel')"
    action-color="error"
    centered
    refreshed
    max-width="520"
    :loading="loading"
    data-cy="sender_email_remove_dialog"
    @action="emit('action')"
    @close="emit('close')"
  >
    <div class="remove-notice">
      <i18n-t keypath="business.emails.remove.body" tag="span">
        <template #address>
          <span class="remove-notice__address">{{ defaultSender }}</span>
        </template>
      </i18n-t>
    </div>
    <p>
      {{ t('business.emails.remove.subBody') }}
    </p>
  </simple-base-dialog>
</template>

<style lang="scss" scoped>
.remove-notice {
  margin-top: 6 * $bw;
  margin-bottom: 5 * $bw;
  padding: 4 * $bw;
  color: $c-grey-darker;
  font-size: 1rem;
  line-height: 1.625rem;
  background-color: $c-grey-light-2;
  border-radius: 6px;

  :deep(.remove-notice__address) {
    font-weight: 800;
  }
}
</style>
